/**
 * Tabblad Klassen: de klassen van deze leerkracht, en per klas de
 * leerlingen met hun inloggegevens.
 */
import React, { useEffect, useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

const LEGE_LEERLING = { naam: '', username: '', password: '' };

export function Klassen({ api, user }) {
  const [klassen, setKlassen] = useState([]);
  const [laden, setLaden] = useState(false);
  const [klas, setKlas] = useState(null);
  const [nieuweKlas, setNieuweKlas] = useState(null);      // { naam, leerjaar } of null
  const [nieuweLeerling, setNieuweLeerling] = useState(null);

  const haalKlassen = async () => {
    setLaden(true);
    try {
      const data = await api.haalKlassen();
      if (data.success) setKlassen(data.data);
    } catch (err) { console.error('Fout:', err); }
    finally { setLaden(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { haalKlassen(); }, []);

  const bekijk = async (id) => {
    try {
      const data = await api.haalKlas(id);
      if (data.success) setKlas(data.data);
    } catch (err) { console.error('Fout:', err); }
  };

  const maakKlas = async (e) => {
    e.preventDefault();
    try {
      const data = await api.maakKlas(nieuweKlas.naam, nieuweKlas.leerjaar, user.id, user.school_id);
      if (data.success) { setNieuweKlas(null); haalKlassen(); }
    } catch (err) { console.error('Fout:', err); }
  };

  const verwijderKlas = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze klas wilt verwijderen?')) return;
    try {
      const data = await api.verwijderKlas(id);
      if (data.success) { haalKlassen(); setKlas(null); }
    } catch (err) { console.error('Fout:', err); }
  };

  const voegLeerlingToe = async (e) => {
    e.preventDefault();
    try {
      const data = await api.maakLeerling(nieuweLeerling, klas.id, user.school_id);
      if (data.success) { setNieuweLeerling(null); bekijk(klas.id); }
      else alert(data.detail || 'Fout');
    } catch (err) { console.error('Fout:', err); }
  };

  const verwijderLeerling = async (id) => {
    if (!window.confirm('Weet je zeker?')) return;
    try {
      const data = await api.verwijderLeerling(id);
      if (data.success) bekijk(klas.id);
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.splitView}>
      <div style={styles.listPanel}>
        <div style={styles.panelHeader}>
          <h2>Mijn Klassen</h2>
          <button onClick={() => setNieuweKlas({ naam: '', leerjaar: 6 })} style={styles.addBtn}>+ Nieuwe Klas</button>
        </div>
        {nieuweKlas && (
          <form onSubmit={maakKlas} style={styles.form}>
            <input type="text" placeholder="Naam van de klas" value={nieuweKlas.naam} onChange={(e) => setNieuweKlas({ ...nieuweKlas, naam: e.target.value })} style={styles.input} required />
            <select value={nieuweKlas.leerjaar} onChange={(e) => setNieuweKlas({ ...nieuweKlas, leerjaar: parseInt(e.target.value) })} style={styles.input}>
              <option value={6}>Leerjaar 6</option>
              <option value={7}>Leerjaar 7</option>
              <option value={8}>Leerjaar 8</option>
            </select>
            <div style={styles.formButtons}>
              <button type="submit" style={styles.saveBtn}>Opslaan</button>
              <button type="button" onClick={() => setNieuweKlas(null)} style={styles.cancelBtn}>Annuleren</button>
            </div>
          </form>
        )}
        {laden ? <p>Laden...</p> : klassen.length === 0 ? <p style={styles.empty}>Nog geen klassen.</p> : (
          <ul style={styles.list}>
            {klassen.map((k) => (
              <li key={k.id} style={klas?.id === k.id ? styles.listItemActive : styles.listItem} onClick={() => bekijk(k.id)}>
                <span>{k.naam} <span style={{ color: kleur.grijs, fontSize: '12px' }}>(leerjaar {k.leerjaar || 6})</span></span>
                <button onClick={(e) => { e.stopPropagation(); verwijderKlas(k.id); }} style={styles.deleteBtn}>🗑️</button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div style={styles.detailPanel}>
        {klas ? (
          <>
            <h2>{klas.naam}</h2>
            <div style={styles.panelHeader}>
              <h3 style={styles.subheader}>Leerlingen ({klas.students?.length || 0})</h3>
              <button onClick={() => setNieuweLeerling(LEGE_LEERLING)} style={styles.addBtn}>+ Leerling</button>
            </div>
            {nieuweLeerling && (
              <form onSubmit={voegLeerlingToe} style={styles.form}>
                <input type="text" placeholder="Naam" value={nieuweLeerling.naam} onChange={(e) => setNieuweLeerling({ ...nieuweLeerling, naam: e.target.value })} style={styles.input} required />
                <input type="text" placeholder="Gebruikersnaam" value={nieuweLeerling.username} onChange={(e) => setNieuweLeerling({ ...nieuweLeerling, username: e.target.value })} style={styles.input} required />
                <input type="text" placeholder="Wachtwoord" value={nieuweLeerling.password} onChange={(e) => setNieuweLeerling({ ...nieuweLeerling, password: e.target.value })} style={styles.input} required />
                <div style={styles.formButtons}>
                  <button type="submit" style={styles.saveBtn}>Toevoegen</button>
                  <button type="button" onClick={() => setNieuweLeerling(null)} style={styles.cancelBtn}>Annuleren</button>
                </div>
              </form>
            )}
            {klas.students?.length > 0 ? (
              <ul style={styles.studentList}>
                {klas.students.map((leerling) => (
                  <li key={leerling.id} style={styles.studentItem}>
                    <div><span>👤 {leerling.naam}</span><span style={styles.username}>@{leerling.username}</span></div>
                    <div style={styles.studentActions}>
                      <button onClick={() => verwijderLeerling(leerling.id)} style={styles.deleteBtn}>🗑️</button>
                    </div>
                  </li>
                ))}
              </ul>
            ) : <p style={styles.empty}>Nog geen leerlingen.</p>}
          </>
        ) : <p style={styles.empty}>Selecteer een klas</p>}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  studentList: { listStyle: 'none', padding: 0 },
  studentItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: kleur.vlak, borderRadius: '6px', marginBottom: '8px' },
  username: { color: kleur.stiller, fontSize: '13px', marginLeft: '8px' },
  studentActions: { display: 'flex', alignItems: 'center', gap: '8px' },
};
